import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataCountry } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_COUNTRY = defineMasterdataEntity<MasterdataCountry>({
  name: 'country',
  responseKey: 'countries',
  supportsFilter: false,
  displayWith: (c) => keyName(c.key, c.name),
  icon: 'fa-regular fa-globe',
  title: 'Ländersuche',
  label: 'Land',
  placeholder: 'Land suchen...',
  columns: [
    {
      label: 'Land',
      type: 'entity',
      icon: 'fa-regular fa-globe',
      value: (e) => keyName(e.key, e.name),
    },
    { label: 'Schlüssel', type: 'text', value: (e) => e.key },
    { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
    { label: 'Handelspartner', type: 'text', value: (e) => e.tradingPartner },
  ],
});
